<template>
  <div class="categoryListing">
    <section class="main_content">
      <div class="cat_wrap">
        <ul class="category_tab">
          <li
            v-for="(category,index) in categories"
            :key="index"
            :class="{'active':index == catIndex}"
          >
            <span @click="getAllCategories(category.id,category.name,index)">{{category.name}}</span>
          </li>
        </ul>
        <div class="rght_tab" :id="parentCategoryId">
          <div class="flx add-margin-option" v-if="parentName">
            <h4>{{parentName}} 
              <!-- <span class="product-count">(1230 {{$t('products')}})</span> -->
            </h4>
            <div class="option_selection">
              <div class="add-option" @click="addParentCatToShop(parentCategoryId)" v-if="$route.query.CLOUDSHOP">ADD TO SHOP</div>
              <div class="add-option" @click="openMainCategoryMargin()" v-else>{{$t('addYourMargin')}}</div>
            </div>
          </div>
          <div class="bottomToUp" v-if="addMainCatMargin"></div>
            <div class="bottomToUp_content" :class="{'activeBottomtoUp' : addMainCatMargin}">
                <div class="popup_content sort supplyItem">
                  <div class="add-category-margin">
                    <h5 class="prdt_hdng">{{parentName}} 
                      <!-- <p class="product-count">1230 {{$t('products')}}</p> -->
                    </h5>                    
                  </div>
                <div class="enter-margin-price">
                    <label for="">{{$t('yourMargin')}}</label>
                    <input type="number" :placeholder="$t('enterMargin')" v-model="addMainCatMarginAmount" />
                    <span class="percent-sign">%</span>
                </div>
                <button type="button" class="add-supply-product" @click="addParentCatMargin(parentCategoryId)">{{$t('addYourMargin')}}</button>
                </div>
                
                <span class="closePopUp" @click="(addMainCatMargin = !addMainCatMargin) && (loading = false)">
                <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23">
                    <path
                    fill="#CDCDCD"
                    fill-rule="nonzero"
                    d="M19.636 3.364C15.15-1.12 7.85-1.122 3.364 3.364c-4.486 4.487-4.485 11.785 0 16.271 4.486 4.487 11.785 4.487 16.272 0 4.485-4.486 4.485-11.785 0-16.27zm-3.599 12.673a.885.885 0 0 1-1.251 0L11.5 12.75l-3.442 3.442a.885.885 0 1 1-1.251-1.251l3.442-3.442-3.286-3.286a.885.885 0 1 1 1.251-1.251l3.286 3.286 3.13-3.13a.885.885 0 1 1 1.25 1.252L12.753 11.5l3.285 3.286a.885.885 0 0 1 0 1.25z"
                    opacity=".675"
                    />
                </svg>
                </span>
            </div>
             <!-- :style="[
              isTileView === 'LIST_VIEW'
                ? { width: '100%' }
                : { width: '49%' },
            ]" -->
          <div class="cata_row">
            <div
              class="prod_col add-margin-option"
              v-for="(subcategory,index) in subCategoriesDto"
              :key="index"
              
            >
              <div class="prod_inner" v-if="subcategory.bgImageURL" @click="goToGetProductByCategory(subcategory.id,subcategory.name)">
                <img :src="subcategory.bgImageURL" alt="subcategory-image" />
              </div>
              <span>{{subcategory.name}}</span>
              <span class="margin-count" v-if="parseFloat(subcategory.marginPercentage)>0">{{parseFloat(subcategory.marginPercentage)}}% Margin Added</span>
              <span class="product-count" v-if="parseFloat(subcategory.totalItems)>0">{{parseFloat(subcategory.totalItems)}} {{$t('products')}}</span>
              <div class="option_selection" v-if="$route.query.CLOUDSHOP">
                <div class="add-option" @click="addSubCatToShop(subcategory.id)">ADD TO SHOP</div>
            </div>
              <div class="option_selection" v-else>
                <div class="add-option active" @click="openAddMarginProduct(index,subcategory.marginPercentage)" v-if="parseFloat(subcategory.marginPercentage) > 0">{{$t('seeMargin')}}</div>
                <div class="add-option" @click="openAddMarginProduct(index)" v-else>{{$t('addYourMargin')}}</div>
            </div>
            <div class="bottomToUp" v-if="addMarginOnProduct === index"></div>
            <div class="bottomToUp_content" :class="{'activeBottomtoUp' : addMarginOnProduct === index}">
                <div class="popup_content sort supplyItem">
                  <div class="add-category-margin">
                    <figure class="cat-image">
                      <img :src="subcategory.bgImageURL" alt="subcategory-image" v-if="subcategory.bgImageURL" />
                      <img src="../../assets/images/watermark1.jpg" alt v-else />
                    </figure>
                    <h5 class="prdt_hdng">{{subcategory.name}} 
                      <p class="product-count">{{subcategory.totalItems}} {{$t('products')}}</p>
                    </h5>
                    
                  </div>
                <div class="enter-margin-price">
                    <label for="">{{$t('yourMargin')}}</label>
                    <input type="number" :placeholder="$t('enterMargin')" v-model="updatedSellingPrice" />
                    <span class="percent-sign">%</span>
                </div>
                <button type="button" class="add-supply-product" @click="addSubCatMargin(subcategory.id)" v-if="parseFloat(subcategory.marginPercentage) > 0">{{$t('updateMargin')}}</button>
                <button type="button" class="add-supply-product" @click="addSubCatMargin(subcategory.id)" v-else>{{$t('addYourMargin')}}</button>
                </div>
                
                <span class="closePopUp" @click="(addMarginOnProduct = !addMarginOnProduct) && (loading = false)">
                <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23">
                    <path
                    fill="#CDCDCD"
                    fill-rule="nonzero"
                    d="M19.636 3.364C15.15-1.12 7.85-1.122 3.364 3.364c-4.486 4.487-4.485 11.785 0 16.271 4.486 4.487 11.785 4.487 16.272 0 4.485-4.486 4.485-11.785 0-16.27zm-3.599 12.673a.885.885 0 0 1-1.251 0L11.5 12.75l-3.442 3.442a.885.885 0 1 1-1.251-1.251l3.442-3.442-3.286-3.286a.885.885 0 1 1 1.251-1.251l3.286 3.286 3.13-3.13a.885.885 0 1 1 1.25 1.252L12.753 11.5l3.285 3.286a.885.885 0 0 1 0 1.25z"
                    opacity=".675"
                    />
                </svg>
                </span>
            </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="cntntLoad" v-if="loading">
      <img src="../../assets/images/loader.gif" alt="loader" />
    </div>
    <CustomToaster :dataValue="toasterData" v-if="isToasterData" />
    <div id="cart-snackbar" :class="{'showMargin': isMarginAdded}">
      <div class="flx">
        <p style="width: 100%;">{{$t('marginAddedSuccessFully')}}</p>
      </div>
      </div>
  </div>
</template>

<script>
import VueCookie from "vue-cookie";
import "../../assets/css/category-tab.scss";
import ApiCaller from "../../utils/apicaller";
import constant from "../../utils/constant";
import CustomToaster from "../../components/Common/CustomToaster";
export default {
  name: "SupplyProductCategoryListing",
  components: {CustomToaster},
  data() {
    return {
      orderDetails: {},
      addressDTO: {},
      subOrderDto: [],
      orderStatus: {},
      loading: false,
      categories: [],
      parentCategoryId: "",
      parentName: "",
      subCategoriesDto: [],
      catIndex: 0,
      addMarginOnProduct: false,
      addMainCatMargin: false,
      updatedSellingPrice: null,
      addMainCatMarginAmount: null,
      toasterData: {},
      isToasterData: false,
      isMarginAdded:  false,
      isTileView: ''
    };
  },
  methods: {
    openMainCategoryMargin(marginPercentage){
      this.addMainCatMargin = true
      // if(marginPercentage){
      //     this.addMainCatMarginAmount = marginPercentage
      //   }
    },
    openAddMarginProduct(index,marginPercentage){
        this.addMarginOnProduct =index;
        if(marginPercentage){
          this.updatedSellingPrice = marginPercentage
        }
    },
    addParentCatToShop(id){
      this.loading = true;
          this.loading = true;
          const obj = {
            categoryId: Number(id),
            subCategoryIds: null,
            sellerMarginPercentage: 0
          }
        ApiCaller(constant.CATALOGUE_URL, `create-seller-category-margin?shopid=${this.$route.query.shopid}`, "post", obj)
        .then((data) => {
          this.$store.commit("saveSubCategories", {
              subCategoriesDto: [],
              subCatId: id
            });
            ApiCaller(constant.CATALOGUE_URL, 'get-category-tree-by-m91supply/'+ id + `?shopid=${this.$route.query.shopid}`, 'get').then(data =>{
              this.subCategoriesDto = []
              this.subCategoriesDto = data.data.childCategories;
              this.loading = false;
              this.addMainCatMargin = false;
              this.addMainCatMarginAmount = null;
              this.isMarginAdded = !this.isMarginAdded
              setTimeout(()=> {
                this.isMarginAdded = !this.isMarginAdded;        
              }, 5000);
            }).catch(err =>{
              this.loading = false;
               this.addMainCatMargin = false;
            })           
        })
        .catch((err) => {
          this.loading = false;
          this.addMainCatMargin = false;
          this.addMainCatMarginAmount = null
          if (
            err.response.data.errorCodes[0] == "ACCESS_DENIED_FOR_MALL91_SUPPLY_PRODUCT_ADD"
          ) {
            this.toasterData = {
              msg: "दुकान की मंजूरी के बाद आप यह सुविधा प्राप्त कर सकते हैं",
              color: "#e51c24",
              iconName: "close",
            };
            this.isToasterData = true;
            }else{
              this.toasterData = {
                msg: "Something went wrong, Please try after sometime",
                color: "#e51c24",
                iconName: "close",
              };
              this.isToasterData = true;
            }
          });
     
    },
    addParentCatMargin(id){
      this.loading = true;
      if(parseFloat(this.addMainCatMarginAmount) > 0 && parseFloat(this.addMainCatMarginAmount) <= 100){
          this.loading = true;
          const obj = {
            categoryId: Number(id),
            subCategoryIds: null,
            sellerMarginPercentage: Math.round(Number(this.addMainCatMarginAmount))
          }
        ApiCaller(constant.CATALOGUE_URL, `create-seller-category-margin?shopid=${this.$route.query.shopid}`, "post", obj)
        .then((data) => {
          this.$store.commit("saveSubCategories", {
              subCategoriesDto: [],
              subCatId: id
            });
            ApiCaller(constant.CATALOGUE_URL, 'get-category-tree-by-m91supply/'+ id + `?shopid=${this.$route.query.shopid}`, 'get').then(data =>{
              this.subCategoriesDto = []
              this.subCategoriesDto = data.data.childCategories;
              this.loading = false;
              this.addMainCatMargin = false;
              this.addMainCatMarginAmount = null;
              this.isMarginAdded = !this.isMarginAdded
              setTimeout(()=> {
                this.isMarginAdded = !this.isMarginAdded;        
              }, 5000);
            }).catch(err =>{
              this.loading = false;
               this.addMainCatMargin = false;
            })           
        })
        .catch((err) => {
          this.loading = false;
          this.addMainCatMargin = false;
          this.addMainCatMarginAmount = null
          if (
            err.response.data.errorCodes[0] == "ACCESS_DENIED_FOR_MALL91_SUPPLY_PRODUCT_ADD"
          ) {
            this.toasterData = {
              msg: "दुकान की मंजूरी के बाद आप यह सुविधा प्राप्त कर सकते हैं",
              color: "#e51c24",
              iconName: "close",
            };
            this.isToasterData = true;
            }else{
              this.toasterData = {
                msg: "Something went wrong, Please try after sometime",
                color: "#e51c24",
                iconName: "close",
              };
              this.isToasterData = true;
            }
          });
        }else{
          // this.addMainCatMargin = false;
          this.loading = false
          this.toasterData = {
              msg: `Please enter margin value between 0 to 100`,
              color: "#E51C24",
              iconName: "close"
          };
          this.isToasterData = true;
        }
     
    },
    addSubCatToShop(id){
          this.loading = true;
          const obj = {
            categoryId: null,
            subCategoryIds: [Number(id)],
            sellerMarginPercentage: 0
          }
        ApiCaller(constant.CATALOGUE_URL, `create-seller-category-margin?shopid=${this.$route.query.shopid}`, "post", obj)
        .then((data) => {
            ApiCaller(constant.CATALOGUE_URL, 'get-category-tree-by-m91supply/'+ this.parentCategoryId + `?shopid=${this.$route.query.shopid}`, 'get').then(data =>{
              this.subCategoriesDto = []
              this.subCategoriesDto = data.data.childCategories;
              this.loading = false;
              this.addMarginOnProduct = false;
              this.updatedSellingPrice = null;
              this.isMarginAdded = !this.isMarginAdded
              setTimeout(()=> {
                this.isMarginAdded = !this.isMarginAdded;        
              }, 5000);
            }).catch(err =>{
              
              this.loading = false;
               this.addMarginOnProduct = false;
            })           
        })
        .catch((err) => {
          this.loading = false;
          this.addMarginOnProduct = false;
          this.updatedSellingPrice = null;
          if (
            err.response.data.errorCodes[0] == "ACCESS_DENIED_FOR_MALL91_SUPPLY_PRODUCT_ADD"
          ) {
            this.toasterData = {
              msg: "दुकान की मंजूरी के बाद आप यह सुविधा प्राप्त कर सकते हैं",
              color: "#e51c24",
              iconName: "close",
            };
            this.isToasterData = true;
            }else{
              this.toasterData = {
                msg: "Something went wrong, Please try after sometime",
                color: "#e51c24",
                iconName: "close",
              };
              this.isToasterData = true;
            }
          });
    },
    addSubCatMargin(id){
      this.loading = true;
      if(parseFloat(this.updatedSellingPrice) > 0 && parseFloat(this.updatedSellingPrice) <= 100){
          this.loading = true;
          const obj = {
            categoryId: null,
            subCategoryIds: [Number(id)],
            sellerMarginPercentage: Math.round(Number(this.updatedSellingPrice))
          }
        ApiCaller(constant.CATALOGUE_URL, `create-seller-category-margin?shopid=${this.$route.query.shopid}`, "post", obj)
        .then((data) => {
            ApiCaller(constant.CATALOGUE_URL, 'get-category-tree-by-m91supply/'+ this.parentCategoryId + `?shopid=${this.$route.query.shopid}`, 'get').then(data =>{
              this.subCategoriesDto = []
              this.subCategoriesDto = data.data.childCategories;
              this.loading = false;
              this.addMarginOnProduct = false;
              this.updatedSellingPrice = null;
              this.isMarginAdded = !this.isMarginAdded
              setTimeout(()=> {
                this.isMarginAdded = !this.isMarginAdded;        
              }, 5000);
            }).catch(err =>{
              
              this.loading = false;
               this.addMarginOnProduct = false;
            })           
        })
        .catch((err) => {
          this.loading = false;
          this.addMarginOnProduct = false;
          this.updatedSellingPrice = null;
          if (
            err.response.data.errorCodes[0] == "ACCESS_DENIED_FOR_MALL91_SUPPLY_PRODUCT_ADD"
          ) {
            this.toasterData = {
              msg: "दुकान की मंजूरी के बाद आप यह सुविधा प्राप्त कर सकते हैं",
              color: "#e51c24",
              iconName: "close",
            };
            this.isToasterData = true;
            }else{
              this.toasterData = {
                msg: "Something went wrong, Please try after sometime",
                color: "#e51c24",
                iconName: "close",
              };
              this.isToasterData = true;
            }
          });
        }else{
          // this.addMainCatMargin = false;
          this.loading = false
          this.toasterData = {
              msg: `Please enter margin value between 0 to 100`,
              color: "#E51C24",
              iconName: "close"
          };
          this.isToasterData = true;
        }
    },
    getAllCategories(categoryId, name, index) {
      this.loading = true;
      this.subCategoriesDto = [];
      this.parentCategoryId = categoryId;
      let payloadObject ;
      if(this.$route.query.shopid){
          payloadObject = categoryId + '?shopid=' + this.$route.query.shopid
        }else{
          payloadObject = categoryId
        }
      ApiCaller(constant.CATALOGUE_URL, 'get-category-tree-by-m91supply/'+ payloadObject, 'get')
        .then(data => {
          this.parentName = name;
          if (categoryId == 0) {
            this.categories = data.data.childCategories;
            this.$store.commit("saveCategories", {
              categories: this.categories,
              catId: categoryId,
              catIndex: index
            });
            //first subcategory
            if (this.categories.length > 0) {
              this.getAllCategories(
                this.categories[0].id,
                this.categories[0].name,
                0
              );
            }
            this.catIndex = index;
            this.loading = false;
          } else {
            this.$store.commit("saveCatId", {
              catId: categoryId,
              catName: name,
              catIndex: index
            });
            if (data.data.childCategories === null) {
              this.subCategoriesDto.push(data.data);
            } else {
              this.subCategoriesDto = data.data.childCategories;
            }
            this.$store.commit("saveSubCategories", {
              subCategoriesDto: this.subCategoriesDto,
              subCatId: categoryId
            });
          }
          this.catIndex = index;
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        });
    },
    goToGetProductByCategory(categoryId, name) {
      if(this.$route.query.CLOUDSHOP){
        this.$router.push(
          "/supply-product-list?type=NORMAL&categoryid=" + categoryId + '&shopid=' + this.$route.query.shopid + '&CLOUDSHOP=YES'
        );
      }else{
          this.$router.push(
          "/supply-product-list?type=NORMAL&categoryid=" + categoryId + '&shopid=' + this.$route.query.shopid
        );
      }
      
       this.$store.commit("saveCategoryFilterData", {
        catfilterProdList: {}
      });
      this.$store.commit("saveCategoriesData", {
        categoriesProdList: [],
        categoriesPageIndex: 0
      });
    }
  },
  mounted() {
    if(this.$store.state.isViewType){
      this.isTileView = this.$store.state.isViewType
    }
    if (this.$store.getters.categories.length > 0) {
      this.categories = this.$store.getters.categories;
      this.catIndex = this.$store.getters.catIndex;
      this.parentName = this.$store.getters.catName;
      
      if (
        this.$store.getters.subCategoriesDto.length > 0 &&
        Number(this.$store.getters.catId) ==
          Number(this.$store.getters.subCatId)
      ) {
        this.parentCategoryId = Number(this.$store.getters.catId);
        this.subCategoriesDto = this.$store.getters.subCategoriesDto;
      } else {
        this.catIndex = 0;
        this.getAllCategories(
          this.categories[0].id,
          this.categories[0].name,
          0
        );
      }
    } else {
      this.catIndex = 0;
      this.getAllCategories(0, "", 0);
    }
  }
};
</script>
<style lang="scss" scoped>
.add-margin-option{
  padding-bottom: 8px;
  h4{
    margin-bottom: 0;
    .product-count{
      display: inline-block;
      color: #138808;
      font-size: 0.75em;
    }
  }
  .margin-count{
    position: absolute;
    left: 0;
    top: 68px;
    background: #008000b8;
    color: #fff;
    border-bottom-right-radius: 5px;
    border-top-right-radius: 5px;
    padding: 2px;
    padding-right: 6px;
    font-size: 0.68em;
    width: 100%;
  }
  .add-option{
    color: #0091FF;
    background: #fff;
    border: 1px solid #0091FF;
    margin-right: 15px;
    padding: 4px 8px;
    border-radius: 5px;
    font-size: 0.75em;
    font-weight: 600;
    white-space: nowrap;
    &.active{
      background: #0091FF;
      color: #fff;
    }
  }
}
.cata_row .prod_col span.product-count{
      display: block;
      color: #138808;
      font-size: 0.75em;
    }
  .product-count{
      display: block;
      color: #138808;
      font-size: 0.875em;
      margin: 4px 0;
    }
.prod_col{
  border-radius: 5px;
  border: 1px solid #ccc;
  padding-bottom: 35px;
  position: relative;
  .add-option{
    margin-right: 0;
    position: absolute;
    bottom: 5px;
    margin: 5px 5px 0;
    width: calc(100% - 10px);
  }
}
</style>